import React from 'react';
import DatePicker from  './DatePicker';
import MonthPicker from  './MonthPicker';
import RangePicker from './RangePicker';
import WeekPicker from './WeekPicker';
import YearPicker from './YearPicker'


DatePicker.MonthPicker = MonthPicker;
DatePicker.RangePicker = RangePicker;
DatePicker.WeekPicker = WeekPicker;
DatePicker.YearPicker = YearPicker;


export default DatePicker;




// WEBPACK FOOTER //
// ./src/index.js